import Button from "./Button"
import './HeadsetListTable.scss';
import { actions } from "../store"
import { useDispatch } from "react-redux"
import { TableRow } from "../table-utils"
import ReactTable, { Column } from "react-table-6"
import { useEffect, useMemo, useState } from "react"
import useWebHidControl from "../api/webhid-control"
import { HidDevice } from "webrtc-client-janus/dist/model";


const HeadsetListTable = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [headsetList, setHeadsetList] = useState<HidDevice[]>([])
  const [selectedRow, setSelectedRow] = useState<HidDevice | null>(null)
  const { getWebHidDeviceList, selectByWebHidDevice, deselectWebHidDevice, selectedWebHidDevice } = useWebHidControl()
  const selectedDevice = useMemo(() => selectedWebHidDevice(), [selectedWebHidDevice])


  useEffect(() => {
    console.log("Loading Headset List")
    getWebHidDeviceList!()
      .then(setHeadsetList)
      .catch(console.error)
      .finally(() => setLoading(false))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const closeModal = () => {
    dispatch(actions.toggleHeadsetListModal())
  }

  const onPairDevice = async () => {
    if (selectedDevice) {
      try {
        await handleUnpair()
      } catch (e) {
        return
      }
    }
    selectByWebHidDevice!(selectedRow!.deviceId)
      .then(() => {
        dispatch(actions.setPairedHeadset(selectedRow!))
        console.log("Paired Device")
        dispatch(actions.showClientNotification("The selected device is now paired."))
        closeModal()
      })
      .catch(console.error)
  }

  const handleUnpair = async () => {
    try {
      await deselectWebHidDevice!().then(() => {
        dispatch(actions.setPairedHeadset(null))
        console.log(`Un-pair Headset Success`)
        dispatch(actions.showClientNotification("The headset is now unpaired."))
      })
    } catch (e) {
      console.error(`Un-pair Headset Error: ${e}`)
      throw e
    }
  }

  const columns: Column<HidDevice>[] = [{
    id: "deviceName",
    Header: "Name",
    width: 200,
    accessor: (a) => a.deviceName,
  }, {
    id: "serialNumber",
    Header: "Serial Number",
    accessor: (a) => a.serialNumber,
    show: false,
  }, {
    id: "deviceId",
    Header: "Product ID",
    width: 150,
    accessor: (a) => a.deviceId,
    show: false,
  }]

  return (
    <div className="HeadsetListTableBody">
      <ReactTable
        data={headsetList}
        columns={columns}
        loading={loading}
        minRows={0}
        showPagination={false}
        noDataText='No Headsets Found'
        getTrProps={(_: any, row?: TableRow<HidDevice>) => ({
          className: row && ((selectedRow && row.original.deviceId === selectedRow.deviceId)) ? 'selected' : undefined,
          onClick() {
            if (!row) { return }
            setSelectedRow(row.original)
          },
        })}
      />
      <footer>
        <Button disabled={!selectedRow} primary onClick={onPairDevice}>{selectedDevice ? 'Re-Pair Device' : 'Pair Device'}</Button>
        <Button onClick={closeModal} type='button'>Cancel</Button>
      </footer>
    </div>
  )
}

export default HeadsetListTable
